// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../registration-vue/node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".password-toggle-button[data-v-0412aa0d]{padding:0;color:#2c5bc5;font:inherit;line-height:inherit;text-decoration:underline}", ""]);
// Exports
module.exports = exports;
